export const adminDashboard = {
  'admin.dashboard.title': 'Panel de Administración',
  'admin.dashboard.subtitle': 'Resumen de la plataforma y métricas clave',
  'admin.dashboard.totalEarnings.lifetime': 'Ganancias Totales de por Vida',
  'admin.dashboard.totalEarnings.lastMonth': 'Ganancias del Mes Pasado',
  'admin.dashboard.additionalMetrics': 'Métricas Adicionales Próximamente',
  'admin.dashboard.charts.accountsProfits': 'Historial de Beneficios de la Plataforma',
  'admin.dashboard.charts.commissionsOverTime': 'Historial de Comisiones',
  'admin.dashboard.charts.totalEarnings': 'Ganancias Totales en el Tiempo',
  'admin.dashboard.users.title': 'Usuarios Totales',
  'admin.dashboard.users.active': 'Usuarios Activos',
  'admin.dashboard.users.newThisMonth': 'Nuevos Este Mes',
  'admin.dashboard.communityValue.title': 'Valor Total de la Comunidad',
  'admin.dashboard.communityValue.description': 'Valor combinado de todas las cuentas de usuario',
  'admin.dashboard.totalEarnings.accountProfit': 'Beneficio de Cuenta',
  'admin.dashboard.totalEarnings.commissionProfit': 'Beneficio de Comisión',
  'admin.dashboard.totalEarnings.description': 'Ganancias combinadas de la plataforma hasta la fecha',
  'admin.dashboard.lastMonthEarnings.description': 'Ganancias de la plataforma para',
};